import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { withStyles, Typography, Button } from '@material-ui/core';
import { hasPermission, formatDate, createHistory } from '../../sc-utilities';
import ColliHistoryList from './ColliHistoryList';
import { Redirect } from 'react-router-dom';

const styles = (theme) => ({
  root: {
    width: `98.9%`,
    height: 'auto',
    paddingTop: theme.spacing(),
    paddingLeft: theme.spacing(),
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      margin: 0,
      width: '100%',
    },
  },
  progressBarr: {
    width: '100%',
    height: 5,
  },
  '@global': {
    "[class*='buttonsCustomer']": {
      margin: theme.spacing(),
      fontSize: '13px',
      width: '100%',
      '&:hover': {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.buttonText.default,
      },
    },
    "[class*='paletteButtons']": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.buttonText.default,
      margin: theme.spacing(),
      '&:hover': {
        backgroundColor: theme.palette.secondary.main,
        textDecoration: 'none',
      },
    },
    "[class*='MuiTableCell-root MuiTableCell-body']": {
      height: '40px',
      padding: '2px',
      fontSize: '0.7rem',
    },
    "[class*='warning']": {
      color: theme.palette.warning.light,
      padding: 1,
      fontSize: 12,
    },
    "[class*='error']": {
      color: theme.palette.dark,
      padding: 1,
      fontSize: 12,
    },
    "[class*='success']": {
      color: theme.palette.success.main,
      padding: 1,
      fontSize: 12,
    },
  },
});

const ColliHistory = (props) => {
  const tableRef = React.createRef();
  const { classes, columns, translations, permissions } = props;
  const [redirectOptions, setRedirectOptions] = useState({ redirect: false, search: null, redirectPath: '', warehouseObj: null });

  let visible = columns && columns['ColliHistory'];

  const tableColumns = useMemo(() => {
    return [{
      title: translations['colli_id'] || 'Colli ID',
      field: 'ColliInventoryID',
      hidden: visible ? visible['ColliInventoryID'] : false,
      filtering: true,
      render: (rowData) => {
        return rowData.Colli && rowData.Colli.ColliInventoryID ? (
          <Button
            color='primary'
            variant='contained'
            href={`/logistic/container?ColliInventoryID=${rowData.Colli.ColliInventoryID}`}
          >
            <Typography variant={'caption'}>
              {rowData.Colli.ColliInventoryID}
            </Typography>
          </Button>
        ) : (
            <Typography variant={'caption'}> n/a </Typography>
          );
      },
    },
    {
      title: translations['colli_type'] || 'Colli type',
      field: 'ColliTypeName',
      hidden: visible ? visible['ColliTypeName'] : false,
      filtering: true,
      render: (rowData) => {
        return rowData.ColliType ? (
          <Button
            color='primary'
            variant='contained'
            onClick={() => redirectHandler('/logistic/colli-type', `?ColliTypeName=${encodeURIComponent(
              rowData.ColliType.Name
            )}&&WarehouseInventoryID=${rowData?.Warehouse?.WarehouseInventoryID}`, { WarehouseID: rowData.WarehouseID, WarehouseInventoryID: rowData?.Warehouse?.WarehouseInventoryID })}
          >
            {' '}
            <Typography variant={'caption'}>
              {rowData.ColliType.Name}
            </Typography>
          </Button>
        ) : (
            <Typography variant={'caption'}> n/a </Typography>
          );
      },
    },
    {
      title: translations['holder_colli'] || 'Holder colli',
      field: 'HolderColli',
      hidden: visible ? visible['HolderColli'] : false,
      filtering: true,
      render: (rowData) => {
        return rowData.HolderColli ? (
          <Button
            color='primary'
            variant='contained'
            href={`/logistic/container?HolderColliInventoryID=${rowData.HolderColli.ColliInventoryID}`}
          >
            <Typography variant={'caption'}>
              {rowData.HolderColli.ColliInventoryID}
            </Typography>
          </Button>
        ) : (
            <Typography variant={'caption'}> n/a </Typography>
          );
      },
    },
    {
      title: translations['arrived_at'] || 'Arrived at',
      field: 'ArrivedAt',
      hidden: visible ? visible['ArrivedAt'] : false,
      filtering: false,
      render: (rowData) => {
        return (
          <Typography variant={'caption'}>
            {rowData.ArrivedAt ? formatDate(rowData.ArrivedAt) : translations['short_not_assigned'] || 'n/a'}
          </Typography>
        );
      },
    },
    {
      title: translations['date_started'] || 'Date started',
      field: 'DateStarted',
      hidden: visible ? visible['DateStarted'] : false,
      filtering: false,
      render: (rowData) => {
        return (
          <Typography variant={'caption'}>
            {rowData.DateStarted ? formatDate(rowData.DateStarted) : translations['short_not_assigned'] || 'n/a'}
          </Typography>
        );
      },
    },
    {
      title: translations['date_end'] || 'Date end',
      field: 'DateEnd',
      hidden: visible ? visible['DateEnd'] : false,
      filtering: false,
      render: (rowData) => {
        return (
          <Typography variant={'caption'}>
            {rowData.DateEnd ? formatDate(rowData.DateEnd) : translations['short_not_assigned'] || 'n/a'}
          </Typography>
        );
      },
    },
    {
      title: translations['finished'] || 'Finished',
      field: 'Finished',
      hidden: visible ? visible['Finished'] : false,
      filtering: false,
      render: (rowData) => {
        return (
          <Typography variant={'caption'}>
            {rowData.Finished ? formatDate(rowData.Finished) : translations['short_not_assigned'] || 'n/a'}
          </Typography>
        );
      },
    },
    ];
  }, [translations, visible])

  const redirectHandler = (path, search, warehouseObj) => {
    createHistory();
    setRedirectOptions({ redirect: true, redirectPath: path, search: search, warehouseObj: warehouseObj })
  };

  if (redirectOptions.redirect) {
    return <Redirect to={{
      pathname: redirectOptions.redirectPath,
      search: redirectOptions.search,
      state: redirectOptions.warehouseObj
    }} />;
  }

  return (
    <div className={classes.root}>
      {hasPermission(permissions, 'colli_history_list') ? (
        <ColliHistoryList tableColumns={tableColumns} tableRef={tableRef} />
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
    permissions: state?.core?.login?.permissions || [],
    fetching: state.logistic.colliHistory.fetching,
  };
};

export default connect(mapStateToProps, null)(withStyles(styles)(ColliHistory));
